import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import {
  SettingsDisclaimerFormValues,
  SettingsDisclaimer,
} from "../models/disclaimers";
import { formatDecimal } from "../common/util/functions";
import { ClientDetailsFormValues } from "../models/client";

export default class DisclaimerStore {
  loadingInitial = true;
  activeTab: number = 0;

  selectedSettingsDisclaimer: SettingsDisclaimerFormValues = {
    id: undefined,
    accountsReceivableMiddle: "",
    invoiceMiddle: "",
    invoiceLeft: "",
    invoiceRight: "",
    estimateMiddle: "",
    estimateLeft: "",
    estimateRight: "",
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  setActiveTab = (activeTab: string | number | undefined) => {
    this.activeTab = activeTab ? Number(activeTab) : 0;
  };

  loadSettingDisclaimer = async () => {
    this.loadingInitial = true;
    try {
      const result = await agent.Disclaimers.getSettingsDisclaimer();
      runInAction(() => {
        this.selectedSettingsDisclaimer = result;
      });
      return result;
    } catch (error) {
      console.log(error);
    } finally {
      runInAction(() => {
        this.loadingInitial = false;
      });
    }
  };

  setSelectedDisclaimer = (values: SettingsDisclaimerFormValues) => {
    this.selectedSettingsDisclaimer = values;
  };

  createSettingsDisclaimer = async (values: SettingsDisclaimerFormValues) => {
    try {
      let mynew: SettingsDisclaimer = new SettingsDisclaimer(values);
      await agent.Disclaimers.addSettingsDisclaimer(mynew);

      runInAction(() => {
        this.setSelectedDisclaimer(values);
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateSettingsDisclaimerEstimate = async (
    values: SettingsDisclaimerFormValues
  ) => {
    try {
      let mynew: SettingsDisclaimer = new SettingsDisclaimer(values);
      await agent.Disclaimers.updateSettingDisclaimerEstimate(mynew);

      runInAction(() => {
        this.setSelectedDisclaimer(values);
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateSettingsDisclaimerInvoice = async (
    values: SettingsDisclaimerFormValues
  ) => {
    try {
      let mynew: SettingsDisclaimer = new SettingsDisclaimer(values);
      await agent.Disclaimers.updateSettingDisclaimerInvoice(mynew);

      runInAction(() => {
        this.setSelectedDisclaimer(values);
      });
    } catch (error) {
      console.log(error);
    }
  };

  updateSettingsDisclaimerAccountsReceivable = async (
    values: SettingsDisclaimerFormValues
  ) => {
    try {
      let mynew: SettingsDisclaimer = new SettingsDisclaimer(values);
      await agent.Disclaimers.updateSettingDisclaimerAccountsReceivable(mynew);

      runInAction(() => {
        this.setSelectedDisclaimer(values);
      });
    } catch (error) {
      console.log(error);
    }
  };

  previewMiddleDisclaimer = (value: string) =>{
    if (value.length > 0 )
    {
      //replace _
      let estimateMiddle = value.replaceAll(/[\r]+/g, '');
      estimateMiddle = estimateMiddle.replaceAll("_ ", "_____ ");
          //replace Sign and Date
      estimateMiddle = estimateMiddle.replaceAll("_SIGN_DATE_", 
      "SIGNED ____________________________________ DATE __________________");
    

      return estimateMiddle;
    }
    return value;
  }

  previewInvoiceMiddleDisclaimer = (
    disclaimerValue: string,
    technicianNames: string[] | undefined, 
    increaseAuthorizedBy: string, 
    originalEstimateAmount: number | undefined
  ) => {

    if(technicianNames && technicianNames.length){

      technicianNames.forEach((techName, nIdx) => {
        const currTech = nIdx + 1;
        disclaimerValue = disclaimerValue.replace(`__<TECHNICIAN_${currTech}>__`, techName);
      });
      const technicianCount = technicianNames.length;

      for (let idx = technicianCount; idx < 4; idx++) {
        const offsetIdx = idx + 1;
        disclaimerValue = disclaimerValue.replace(
          `Technician ${offsetIdx}: __<TECHNICIAN_${offsetIdx}>__\n`,
          ""
        );
      }
  
    }
    else
    {
      for (let idx = 0; idx < 4; idx++) {
        const offsetIdx = idx + 1;
        disclaimerValue = disclaimerValue.replace(
          `Technician ${offsetIdx}: __<TECHNICIAN_${offsetIdx}>__\n`,
          ""
        );
      }
  
    }

    if(increaseAuthorizedBy)
      disclaimerValue = disclaimerValue.replace('__<INCREASE_AUTHORIZED_BY>__', increaseAuthorizedBy);
    else
      disclaimerValue = disclaimerValue.replace('__<INCREASE_AUTHORIZED_BY>__', '____________________________');


    if(originalEstimateAmount)
      disclaimerValue = disclaimerValue.replace('__<ORIGINAL_ESTIMATE_AMOUNT>__', formatDecimal(originalEstimateAmount, 2));
    else
      disclaimerValue = disclaimerValue.replace('__<ORIGINAL_ESTIMATE_AMOUNT>__', '______________________________');
    
    return disclaimerValue;
  }

  previewARMiddleDisclaimer = (
    disclaimerValue: string,
    clientDetails: ClientDetailsFormValues
  ) => {
    const details = [
      clientDetails.name,
      clientDetails.addressLine1,
      clientDetails.addressLine2,
      `${clientDetails.city} ${clientDetails.state} ${clientDetails.postalCode}`
    ];

    return disclaimerValue.replace('__<Company Name and Address>__', "\n" + details.filter(x => x && (x.length > 0)).join("\n"));
  }
}
